export const groupCitySpecs = [
  ["birmingham", "Birmingham", "B1", "M40 / M42", "2-3 hr", "New Street, Birmingham Airport and the NEC", "city-centre bus gates and NEC event traffic"],
  ["manchester", "Manchester", "M1", "M40 / M6", "3.5-5 hr", "Piccadilly, Manchester Airport and central hotels", "M6 congestion, comfort stops and city-centre loading"],
  ["oxford", "Oxford", "OX1", "M25 / M40", "55-90 min", "Oxford station, colleges and city-centre hotels", "restricted central streets and designated group drop-off points"],
  ["reading", "Reading", "RG1", "M4", "40-70 min", "Reading station, Thames Valley offices and central hotels", "M4 peak traffic and station-area loading"],
  ["southampton", "Southampton", "SO14", "M25 / M3", "1.5-2.5 hr", "Southampton Central, cruise terminals and the university", "cruise check-in times and port access"],
  ["cambridge", "Cambridge", "CB1", "M25 / M11", "1.5-2.5 hr", "Cambridge station, colleges and the Biomedical Campus", "restricted historic-centre access and college drop-offs"],
  ["bristol", "Bristol", "BS1", "M4 / M32", "1.5-2.5 hr", "Temple Meads, the city centre and university areas", "M32 approaches, clean-air-zone routing and central loading"],
  ["milton-keynes", "Milton Keynes", "MK9", "M25 / M1", "1.25-2 hr", "Milton Keynes Central, Stadium MK and business districts", "event traffic and the correct numbered grid-road entrance"],
  ["cardiff", "Cardiff", "CF10", "M4", "2.25-3.5 hr", "Cardiff Central, city-centre hotels and Principality Stadium", "Severn crossing conditions and stadium event restrictions"],
  ["nottingham", "Nottingham", "NG1", "M25 / M1", "2.5-4 hr", "Nottingham station, universities and city-centre venues", "tram corridors, city-centre access and planned comfort stops"],
  ["leicester", "Leicester", "LE1", "M25 / M1", "2-3 hr", "Leicester station, universities and King Power Stadium", "match-day traffic and city-centre loading restrictions"],
  ["coventry", "Coventry", "CV1", "M40 / A46", "1.75-3 hr", "Coventry station, the university and Coventry Building Society Arena", "A46 conditions and arena event traffic"],
  ["portsmouth", "Portsmouth", "PO1", "M25 / A3", "1.5-2.5 hr", "Portsmouth & Southsea, the International Port and Gunwharf Quays", "ferry check-in deadlines and waterfront access"],
  ["brighton", "Brighton", "BN1", "M25 / M23", "1.5-2.5 hr", "Brighton station, seafront hotels and conference venues", "seafront congestion and limited coach loading bays"],
  ["bournemouth", "Bournemouth", "BH1", "M3 / M27 / A31", "2-3 hr", "Bournemouth station, seafront hotels and the university", "A31 traffic and seasonal seafront access"],
  ["york", "York", "YO1", "M1 / A1(M)", "4-5.5 hr", "York station, universities and the historic centre", "long-distance comfort stops and city-wall access restrictions"],
  ["leeds", "Leeds", "LS1", "M1", "3.5-5 hr", "Leeds station, universities and city-centre venues", "M1 delays, comfort stops and central loading bays"],
  ["sheffield", "Sheffield", "S1", "M1", "3-4.5 hr", "Sheffield station, universities and Utilita Arena", "M1 conditions, hills and event-day access"],
];

const airportTerms = ["HEATHROW", "LHR", "TW6"];
const containsAny = (value, terms) => terms.some((term) => String(value || "").toUpperCase().includes(term));
const cityValidator = (city, postcode) => (value = "") =>
  containsAny(value, [city.toUpperCase(), postcode.toUpperCase()]);
const heathrowValidator = (value = "") => containsAny(value, airportTerms);

const vehicleConfig = (citySpec, direction, vehicle) => {
  const [slug, city, postcode, roads, , hubs] = citySpec;
  const fromAirport = direction === "from-airport";
  const routeName = fromAirport ? `Heathrow to ${city}` : `${city} to Heathrow`;
  const isCoach = vehicle === "coach";
  const vehicleLabel = isCoach ? "coach" : "minibus";
  return {
    brand: isCoach ? "CheapCoachGrab" : "MinibusGrab",
    domain: isCoach ? "https://www.cheapcoachgrab.com" : "https://www.minibusgrab.com",
    className: isCoach ? "coachgrab-v2-home" : "minibusgrab-v2-home",
    vehicle,
    path: `/${fromAirport ? `heathrow-to-${slug}` : `${slug}-to-heathrow`}-${vehicle}`,
    title: `${routeName} ${isCoach ? "Coach" : "Minibus"} Hire | ${isCoach ? "CheapCoachGrab" : "MinibusGrab"}`,
    description: `${routeName} ${vehicleLabel} hire for groups travelling via ${roads}. Get a fixed quote for ${hubs}, with Heathrow flight, terminal and road checks.`,
    keywords: `${routeName} ${vehicleLabel} hire, Heathrow ${vehicleLabel} ${city}, ${city} airport group transfer, ${vehicleLabel} hire ${postcode}`,
    h1: `${routeName} ${vehicleLabel} hire with live journey intelligence`,
    intro: fromAirport
      ? `Group transfers from Heathrow Terminals 2 to 5 to ${city}, planned around flight arrivals, luggage, operator availability and live road conditions.`
      : `Group transfers from ${city} to Heathrow Terminals 2 to 5, planned around pickup timing, luggage, check-in targets and live road conditions.`,
    quoteLabel: `Get ${isCoach ? "Coach" : "Minibus"} Quote`,
    passengers: isCoach ? 25 : 8,
    bags: 0,
    resultPath: isCoach ? "/coach-results" : "/minibus-results",
    resultQuery: isCoach ? "vehicle=twentyfive" : "vehicles=nine,fourteen",
    seats: isCoach ? "25 to 53 seaters" : "8 to 16 seaters",
    fleet: isCoach
      ? ["25 seater mini coach", "33 to 49 seater coaches", "53 seater high-capacity options"]
      : ["8 passenger / 9-seater minibuses", "14 to 16 passenger minibuses", "Luggage-ready licensed partner options"],
  };
};

const makeRoute = ([slug, city, postcode, roads, time, hubs, access], direction) => {
  const fromAirport = direction === "from-airport";
  const routeName = fromAirport ? `Heathrow to ${city}` : `${city} to Heathrow`;
  const cityCheck = cityValidator(city, postcode);
  return {
    routeKey: fromAirport ? "heathrow" : slug,
    showPricePreview: false,
    liveStripVariant: fromAirport ? "heathrow-city" : "heathrow",
    pageClassName: "generated-city-route-v2",
    heroEyebrow: `${routeName} route`,
    metrics: [postcode, `${time} typical`, "__SEATS__", `${roads} live checks`],
    areas: ["Heathrow Airport", city],
    seo: {
      routeName: `${routeName} group transfer`,
      areaServed: ["Heathrow Airport", city],
      origin: fromAirport ? "Heathrow Airport" : city,
      destination: fromAirport ? city : "Heathrow Airport",
    },
    quote: {
      formId: `${fromAirport ? `heathrow-${slug}` : `${slug}-heathrow`}-route-quote`,
      pickupDefault: fromAirport ? "Heathrow Airport" : `${city}, ${postcode}`,
      dropoffDefault: fromAirport ? `${city}, ${postcode}` : "Heathrow Airport",
      pickupAriaLabel: fromAirport ? "Heathrow terminal or pickup point" : `${city} pickup postcode or address`,
      dropoffAriaLabel: fromAirport ? `${city} drop-off postcode or address` : "Heathrow terminal or drop-off",
      pickupPlaceholder: fromAirport ? "Enter Heathrow terminal or pickup point" : `Enter ${city} pickup`,
      dropoffPlaceholder: fromAirport ? `Enter ${city} destination` : "Enter Heathrow terminal",
      validatePickup: fromAirport ? heathrowValidator : cityCheck,
      validateDropoff: fromAirport ? cityCheck : heathrowValidator,
      pickupError: fromAirport ? "Please enter Heathrow Airport, LHR, TW6 or a Heathrow terminal." : `Please enter a ${city} or ${postcode} pickup.`,
      dropoffError: fromAirport ? `Please enter a ${city} or ${postcode} destination.` : "Please enter Heathrow Airport, LHR, TW6 or a Heathrow terminal.",
      genericError: `We could not calculate a quote for this ${routeName} journey. Please check the details and try again.`,
    },
    compactStatusTitle: `${routeName} live checks`,
    reviews: {
      minibus: [
        ["Aisha K.", `Keeping our group together for ${routeName} was much easier than arranging several cars.`],
        ["Martin R.", `Clear ${routeName} quote with sensible luggage and timing questions.`],
        ["Priya S.", "Useful airport and road checks before confirming the group journey."],
      ],
      coach: [
        ["Rachel T.", `The ${routeName} coach enquiry covered passenger numbers, luggage and access clearly.`],
        ["Imran S.", "Good support for a larger company group and a long airport transfer."],
        ["Claire B.", "The route checks helped us plan the group schedule with more confidence."],
      ],
    },
    proofCards: [
      { eyebrow: "Licensed operators", title: "Registered and insured", body: "Licensed minibus and PSV partners according to the selected vehicle." },
      { eyebrow: "Route planning", title: roads, body: `Live road conditions matter on the ${routeName} corridor.` },
      { eyebrow: "Group travel", title: "Passengers and luggage together", body: "Vehicle capacity is planned around the full group and its luggage." },
    ],
    chooseTitle: `Built for ${routeName} groups`,
    chooseCards: [
      { title: "One vehicle for the group", body: "Keep passengers, luggage and journey instructions together." },
      { title: "Long-distance timing", body: `${roads} traffic, stops and loading time can change the schedule.` },
      { title: "Airport-aware planning", body: "Terminal, flight and queue context remains visible before booking." },
      { title: "Fixed quote flow", body: "Enter the route once and continue through the relevant group vehicle results." },
    ],
    routeContentCards: [
      { title: `${city} pickup and drop-off points`, body: `We serve ${hubs}. Enter the exact address or ${postcode} postcode so vehicle access can be checked.` },
      { title: fromAirport ? "Meeting your group at Heathrow" : "Arriving at the correct terminal", body: fromAirport ? "Add the flight number and Terminal 2, 3, 4 or 5 so arrival monitoring and the meeting plan match." : "Specify Terminal 2, 3, 4 or 5, the flight departure time and your airline when planning the pickup." },
      { title: "Road corridor", body: `${roads} is the main planning corridor, with alternatives depending on live disruption.` },
      { title: "Typical journey time", body: `Allow around ${time}, then add loading, stops and peak-traffic contingency.` },
      { title: `${city} access planning`, body: `The journey plan accounts for ${access}. Share venue instructions before travel.` },
      {
        title: `Plan the reverse ${city} route`,
        body: `Travelling ${fromAirport ? "to Heathrow instead" : `back to ${city}`}? Use the matching reverse-direction page with the correct booking defaults.`,
        links: (vehicle) => [{
          to: `/${fromAirport ? `${slug}-to-heathrow` : `heathrow-to-${slug}`}-${vehicle}`,
          label: `${fromAirport ? city : "Heathrow"} to ${fromAirport ? "Heathrow" : city} ${vehicle}`,
        }],
      },
    ],
    faqItems: [
      { question: `How long does ${routeName} take?`, answer: `A typical journey is around ${time}, but traffic, stops, terminal and loading time can change this.` },
      { question: "Do you cover every Heathrow terminal?", answer: "Yes. Enter Terminal 2, 3, 4 or 5 and provide the flight details during booking." },
      { question: `Can you serve hotels and stations in ${city}?`, answer: `Yes. Enter the exact ${city} pickup or drop-off point so access can be checked.` },
      { question: "Should we choose a minibus or coach?", answer: "Use a minibus for 8 to 16 passengers and a coach for larger organised groups." },
      { question: `What should we provide for a ${city} group booking?`, answer: `Provide passenger and luggage totals, the exact ${city} address, Heathrow terminal, flight number and any stops or accessibility requirements.` },
    ],
    pricePreviewTitle: (vehicle) => `${routeName} ${vehicle} previews`,
    routeOverviewTitle: `${routeName} route notes`,
    routeOverviewIntro: `${routeName} is a longer group transfer where ${roads} conditions, stops, luggage and airport timing should be agreed before travel.`,
    vehicleContextTitle: (brand) => `${brand} options for ${routeName}`,
    faqEyebrow: `${city} / LHR FAQ`,
    faqTitle: "Common questions before booking",
    support: {
      title: `Need help planning a ${routeName} group transfer?`,
      body: "Use the quote form first, or contact support for multiple stops, luggage, flight arrivals, hotel access or coach loading questions.",
      nudgeText: `Need ${city} group transfer help?`,
    },
  };
};

export const generatedGroupRouteConfigs = {};
export const generatedGroupRouteRoutes = [];

groupCitySpecs.forEach((citySpec) => {
  const [slug] = citySpec;
  ["to-airport", "from-airport"].forEach((direction) => {
    const fromAirport = direction === "from-airport";
    const routeKey = fromAirport ? `heathrow-to-${slug}` : `${slug}-to-heathrow`;
    generatedGroupRouteConfigs[routeKey] = {
      configs: {
        minibus: vehicleConfig(citySpec, direction, "minibus"),
        coach: vehicleConfig(citySpec, direction, "coach"),
      },
      route: makeRoute(citySpec, direction),
    };
    ["minibus", "coach"].forEach((variant) => {
      const base = `/${routeKey}-${variant}`;
      generatedGroupRouteRoutes.push({ path: base, routeKey, variant });
      generatedGroupRouteRoutes.push({ path: `${base}-hire`, routeKey, variant });
    });
  });
});

const heathrowLocalOutboundCities = [
  ["maidenhead", "Maidenhead", "SL6", "M4 / A4", "25-45 min", "Maidenhead station, Cookham, Bray, Taplow and SL6 hotels", "M4 pressure, riverside venue access and the exact SL6 drop-off"],
  ["slough", "Slough", "SL1", "M4 / A4", "15-30 min", "Slough station, Langley, Burnham, Trading Estate and local hotels", "M4 junction traffic, hotel forecourts and central Slough loading"],
  ["windsor", "Windsor", "SL4", "M4 / M25 / A308", "15-35 min", "Windsor Castle, Eton, LEGOLAND, Datchet and SL4 hotels", "visitor traffic, hotel access and restricted Castle-area pickup points"],
];

heathrowLocalOutboundCities.forEach((citySpec) => {
  const [slug] = citySpec;
  const routeKey = `heathrow-to-${slug}`;
  generatedGroupRouteConfigs[routeKey] = {
    configs: {
      minibus: vehicleConfig(citySpec, "from-airport", "minibus"),
      coach: vehicleConfig(citySpec, "from-airport", "coach"),
    },
    route: makeRoute(citySpec, "from-airport"),
  };
  ["minibus", "coach"].forEach((variant) => {
    const base = `/${routeKey}-${variant}`;
    generatedGroupRouteRoutes.push({ path: base, routeKey, variant });
    generatedGroupRouteRoutes.push({ path: `${base}-hire`, routeKey, variant });
  });
});

const londonSpec = ["london", "London", "W1", "M4 / A4 / M25", "35-90 min", "central London hotels, mainline stations and event venues", "congestion, loading restrictions and the selected central London zone"];
generatedGroupRouteConfigs["london-to-heathrow"] = {
  configs: {
    minibus: vehicleConfig(londonSpec, "to-airport", "minibus"),
    coach: vehicleConfig(londonSpec, "to-airport", "coach"),
  },
  route: makeRoute(londonSpec, "to-airport"),
};
["minibus", "coach"].forEach((variant) => {
  const base = `/london-to-heathrow-${variant}`;
  generatedGroupRouteRoutes.push({ path: base, routeKey: "london-to-heathrow", variant });
  generatedGroupRouteRoutes.push({ path: `${base}-hire`, routeKey: "london-to-heathrow", variant });
});

const manchesterAirportCitySpecs = [
  ["liverpool", "Liverpool", "L1", "M56 / M62", "45-75 min", "Liverpool Lime Street, city-centre hotels, the waterfront and event venues", "city-centre loading, match-day traffic and the exact group pickup point"],
  ["leeds", "Leeds", "LS1", "M56 / M60 / M62", "1.25-2 hr", "Leeds station, universities, city-centre hotels and event venues", "M62 traffic, city-centre access and planned group loading"],
  ["sheffield", "Sheffield", "S1", "A555 / A6 / A623", "1.25-2 hr", "Sheffield station, universities, city-centre hotels and event venues", "Peak District road conditions, hills and event-day access"],
];

const manchesterAirportTerms = ["MANCHESTER AIRPORT", "MAN AIRPORT", "M90"];
const manchesterAirportValidator = (value = "") => containsAny(value, manchesterAirportTerms);

const manchesterVehicleConfig = (citySpec, direction, vehicle = "minibus") => {
  const [slug, city, postcode, roads, , hubs] = citySpec;
  const fromAirport = direction === "from-airport";
  const routeName = fromAirport ? `Manchester Airport to ${city}` : `${city} to Manchester Airport`;
  const isCoach = vehicle === "coach";
  const brand = isCoach ? "CheapCoachGrab" : "MinibusGrab";

  return {
    brand,
    domain: isCoach ? "https://www.cheapcoachgrab.com" : "https://www.minibusgrab.com",
    className: isCoach ? "coachgrab-v2-home" : "minibusgrab-v2-home",
    vehicle,
    path: `/${fromAirport ? `manchester-airport-to-${slug}` : `${slug}-to-manchester-airport`}-${vehicle}`,
    title: `${routeName} ${isCoach ? "Coach" : "Minibus"} Hire | ${brand}`,
    description: isCoach
      ? `${routeName} coach hire for larger groups travelling via ${roads}. Request a fixed quote for ${hubs}, with live Manchester Airport checks.`
      : `${routeName} minibus hire for 8 to 16 passengers travelling via ${roads}. Request a fixed quote for ${hubs}, with live Manchester Airport checks.`,
    keywords: `${routeName} ${vehicle} hire, Manchester Airport ${vehicle} ${city}, ${city} airport group transfer, ${vehicle} hire ${postcode}`,
    h1: `${routeName} ${vehicle} hire with live airport intelligence`,
    intro: fromAirport
      ? `Group transfers from Manchester Airport Terminals 1 to 3 to ${city}, planned around flight arrivals, luggage, operator availability and live road conditions.`
      : `Group transfers from ${city} to Manchester Airport Terminals 1 to 3, planned around pickup timing, luggage, check-in targets and live road conditions.`,
    quoteLabel: isCoach ? "Get Coach Quote" : "Get Minibus Quote",
    passengers: isCoach ? 25 : 8,
    bags: 0,
    resultPath: isCoach ? "/coach-results" : "/minibus-results",
    resultQuery: isCoach ? "vehicle=twentyfive" : "vehicles=nine,fourteen",
    seats: isCoach ? "25 to 53 seaters" : "8 to 16 seaters",
    fleet: isCoach
      ? ["25 seater mini coach", "33 to 49 seater coaches", "53 seater high-capacity options"]
      : ["8 passenger / 9-seater minibuses", "14 to 16 passenger minibuses", "Luggage-ready licensed partner options"],
  };
};

const makeManchesterRoute = ([slug, city, postcode, roads, time, hubs, access], direction) => {
  const fromAirport = direction === "from-airport";
  const routeName = fromAirport ? `Manchester Airport to ${city}` : `${city} to Manchester Airport`;
  const cityCheck = cityValidator(city, postcode);
  const reversePath = fromAirport
    ? `/${slug}-to-manchester-airport-minibus`
    : `/manchester-airport-to-${slug}-minibus`;

  return {
    routeKey: "manchester",
    liveStripVariant: "manchester",
    pageClassName: "generated-manchester-route-v2",
    heroEyebrow: `${routeName} route`,
    metrics: [postcode, `${time} typical`, "__SEATS__", `${roads} live checks`],
    areas: ["Manchester Airport", city],
    seo: {
      routeName: `${routeName} group transfer`,
      serviceType: "Manchester Airport minibus transfer",
      areaServed: ["Manchester Airport", city],
      origin: fromAirport ? "Manchester Airport" : city,
      destination: fromAirport ? city : "Manchester Airport",
    },
    quote: {
      formId: `${fromAirport ? `manchester-airport-${slug}` : `${slug}-manchester-airport`}-route-quote`,
      pickupDefault: fromAirport ? "Manchester Airport, M90 1QX" : `${city}, ${postcode}`,
      dropoffDefault: fromAirport ? `${city}, ${postcode}` : "Manchester Airport, M90 1QX",
      pickupAriaLabel: fromAirport ? "Manchester Airport terminal or pickup point" : `${city} pickup postcode or address`,
      dropoffAriaLabel: fromAirport ? `${city} drop-off postcode or address` : "Manchester Airport terminal or drop-off",
      pickupPlaceholder: fromAirport ? "Enter Manchester Airport terminal" : `Enter ${city} pickup`,
      dropoffPlaceholder: fromAirport ? `Enter ${city} destination` : "Enter Manchester Airport terminal",
      validatePickup: fromAirport ? manchesterAirportValidator : cityCheck,
      validateDropoff: fromAirport ? cityCheck : manchesterAirportValidator,
      pickupError: fromAirport ? "Please enter Manchester Airport, MAN or an M90 address." : `Please enter a ${city} or ${postcode} pickup.`,
      dropoffError: fromAirport ? `Please enter a ${city} or ${postcode} destination.` : "Please enter Manchester Airport, MAN or an M90 address.",
      genericError: `We could not calculate a quote for this ${routeName} journey. Please check the details and try again.`,
    },
    showHeathrowStatus: true,
    statusAirportCode: "MAN",
    statusAirportName: "Manchester Airport",
    compactStatusTitle: `${routeName} live checks`,
    compactStatusKicker: "Live MAN intelligence",
    compactStatusFootnote: "Roads, flights, terminals, rail and weather are checked before Manchester Airport group journeys.",
    fullStatusPath: null,
    showRouteIntelligence: false,
    showPricePreview: false,
    reviews: {
      minibus: [
        ["Aisha K.", `Keeping our group together for ${routeName} was easier than arranging several cars.`],
        ["Martin R.", `The ${routeName} quote covered our luggage and timing clearly.`],
        ["Priya S.", "Useful Manchester Airport and road checks before confirming the group journey."],
      ],
    },
    proofCards: [
      { eyebrow: "Licensed operators", title: "Registered and insured", body: "Licensed minibus or PSV coach partners matched to the selected group vehicle." },
      { eyebrow: "Manchester Airport aware", title: "Terminals 1, 2 and 3", body: "Flight, terminal and airport approach details are checked before travel." },
      { eyebrow: "Group travel", title: "Passengers and luggage together", body: "Vehicle capacity is planned around the whole group and its luggage." },
    ],
    chooseTitle: `Built for ${routeName} groups`,
    chooseCards: [
      { title: "One vehicle for the group", body: "Keep passengers, luggage and journey instructions together." },
      { title: "Route-aware timing", body: `${roads} traffic and loading time can change the schedule.` },
      { title: "Airport-aware planning", body: "Terminal, flight and live airport context remain visible before booking." },
      { title: "Fixed quote flow", body: "Enter the route once and continue through the relevant group vehicle results." },
    ],
    routeContentCards: [
      { title: `${city} pickup and drop-off points`, body: `We serve ${hubs}. Enter the exact address or ${postcode} postcode so vehicle access can be checked.` },
      { title: fromAirport ? "Meeting at Manchester Airport" : "Arriving at the correct terminal", body: fromAirport ? "Add the flight number and Terminal 1, 2 or 3 so arrival monitoring and the meeting plan match." : "Specify Terminal 1, 2 or 3, the flight departure time and airline when planning pickup." },
      { title: "Road corridor", body: `${roads} is the main planning corridor, with alternatives depending on live disruption.` },
      { title: "Typical journey time", body: `Allow around ${time}, then add loading and peak-traffic contingency.` },
      { title: `${city} access planning`, body: `The journey plan accounts for ${access}. Share venue instructions before travel.` },
      { title: `Plan the reverse ${city} route`, body: "Use the matching reverse-direction page so the airport and city defaults are correct.", links: (vehicle) => vehicle === "coach" ? [] : [{ to: reversePath, label: `${fromAirport ? city : "Manchester Airport"} to ${fromAirport ? "Manchester Airport" : city} minibus` }] },
    ],
    faqItems: [
      { question: `How long does ${routeName} take?`, answer: `A typical journey is around ${time}, but traffic, terminal and group loading can change this.` },
      { question: "Do you cover every Manchester Airport terminal?", answer: "Yes. Enter Terminal 1, 2 or 3 and provide the flight details during booking." },
      { question: `Can you serve hotels and stations in ${city}?`, answer: `Yes. Enter the exact ${city} pickup or drop-off point so access can be checked.` },
      { question: "Which group vehicle sizes are available?", answer: "Minibus options cover typical 8 to 16 passenger groups, while coach options support larger organised groups, subject to luggage and vehicle availability." },
    ],
    routeOverviewTitle: `${routeName} route notes`,
    routeOverviewIntro: `${routeName} group transfers depend on ${roads} conditions, terminal timing, luggage and the exact pickup point.`,
    vehicleContextTitle: (brand) => `${brand} options for ${routeName}`,
    faqEyebrow: `${city} / MAN FAQ`,
    faqTitle: "Common questions before booking",
    support: {
      title: `Need help planning a ${routeName} group transfer?`,
      body: "Use the quote form first, or contact support for multiple stops, luggage, flight arrivals or hotel access.",
      nudgeText: `Need ${city} group transfer help?`,
    },
  };
};

manchesterAirportCitySpecs.forEach((citySpec) => {
  const [slug] = citySpec;
  ["from-airport", "to-airport"].forEach((direction) => {
    const fromAirport = direction === "from-airport";
    const routeKey = fromAirport ? `manchester-airport-to-${slug}` : `${slug}-to-manchester-airport`;
    generatedGroupRouteConfigs[routeKey] = {
      configs: { minibus: manchesterVehicleConfig(citySpec, direction) },
      route: makeManchesterRoute(citySpec, direction),
    };
    generatedGroupRouteRoutes.push({ path: `/${routeKey}-minibus`, routeKey, variant: "minibus" });
  });
});

const leedsManchesterCoachKey = "leeds-to-manchester-airport";
const leedsManchesterCoachEntry = generatedGroupRouteConfigs[leedsManchesterCoachKey];
leedsManchesterCoachEntry.configs.coach = manchesterVehicleConfig(
  manchesterAirportCitySpecs.find(([slug]) => slug === "leeds"),
  "to-airport",
  "coach"
);
generatedGroupRouteRoutes.push({
  path: "/leeds-to-manchester-airport-coach",
  routeKey: leedsManchesterCoachKey,
  variant: "coach",
});

export default generatedGroupRouteConfigs;
